export default {
    groupName: 'genesis',
    appName: 'Genesis',
    baseRoute: '/dashboard/genesis',
    label: 'Genesis Ad Effect Tracker',
    home: '/slicer',
    image: 'genesis.png',
    description: 'Genesis Ad Effect Tracker'
}


// WEBPACK FOOTER //
// ./src/app/configuration/Genesis/config/main.js